module.exports = function PanoramaCoaches(container,options)
{
	this.cubeImages = [
		"blank.jpg",
		"blank.jpg",
		"blank.jpg",
		"blank.jpg",
		"blank.jpg",
		"blank.jpg"
	];
	this.hotspots = [];
	this.basePath = "";
	if(typeof options.basePath !== "undefined")
		this.basePath = options.basePath;
	this.titleSize = 3384;
	
	this.pano = null;
	
	this.pano2vrSkin = function (player,cocheObj,base) {
		var me=this;
		var flag=false;
		var nodeMarker=new Array();
		var activeNodeMarker=new Array();
		this.player=player;
		this.player.skinObj=this;
		this.divSkin=player.divSkin;
		var basePath="";
		if (base=='?') {
			var scripts = document.getElementsByTagName('script');
			for(var i=0;i<scripts.length;i++) {
				var src=scripts[i].src;
				if (src.indexOf('skin.js')>=0) {
					var p=src.lastIndexOf('/');
					if (p>=0) {
						basePath=src.substr(0,p+1);
					}
				}
			}
		} else
		if (base) {
			basePath=base;
		}
		this.elementMouseDown=new Array();
		this.elementMouseOver=new Array();
		var cssPrefix='';
		var domTransition='transition';
		var domTransform='transform';
		var prefixes='Webkit,Moz,O,ms,Ms'.split(',');
		var i;
		for(i=0;i<prefixes.length;i++) {
			if (typeof document.body.style[prefixes[i] + 'Transform'] !== 'undefined') {
				cssPrefix='-' + prefixes[i].toLowerCase() + '-';
				domTransition=prefixes[i] + 'Transition';
				domTransform=prefixes[i] + 'Transform';
			}
		}
		
		
		function SkinHotspotClass(skinObj,hotspot) {
			var me=this;
			var flag=false;
			this.player=skinObj.player;
			this.skin=skinObj;
			this.hotspot=hotspot;
			this.elementMouseDown=new Array();
			this.elementMouseOver=new Array();
			this.__div=document.createElement('div');
			this.__div.setAttribute('style','position:absolute; left:0px;top:0px;visibility: inherit;');
			
			this.findElements=function(id,regex) {
				return me.skin.findElements(id,regex);
			}
			
			{
				this.__div=document.createElement('div');
				this.__div.ggId="hotspot";
				this.__div.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
				this.__div.ggVisible=true;
				this.__div.className='ggskin ggskin_hotspot';
				this.__div.ggType='hotspot';
				var hs ='position:absolute;';
				hs+='left: 350px;';
				hs+='top:  20px;';
				hs+=cssPrefix + 'transform-origin: 50% 50%;';
				hs+='visibility: inherit;';
				this.__div.setAttribute('style',hs);
				
				this._hsimage=document.createElement('div');
				this._hsimage.ggId="hsimage";
				this._hsimage.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
				this._hsimage.ggVisible=true;
				this._hsimage.className='ggskin ggskin_textdiv';
				this._hsimage.ggType='svg';
				//hs ='position:absolute;';
				hs+='left: -75px;';
				hs+='top:  -16px;';
				hs+=cssPrefix + 'transform-origin: 50% 50%;';
				hs+='visibility: inherit;';
				hs+='cursor: pointer;';
				this._hsimage.setAttribute('style',hs);
				this._hsimage.setAttribute('panoId',me.hotspot.id);
				this.__div.onclick=function () {
					if(typeof cocheObj.hotspots[me.hotspot.id] !== "undefined" && typeof cocheObj.hotspots[me.hotspot.id].callback == "function")
						cocheObj.hotspots[me.hotspot.id].callback(me.hotspot.id);
				}
				this._hsimage__text = document.createElement('div');
				this._hsimage__text.className='ggskin ggskin_text';
				this._hsimage__text.innerHTML = me.hotspot.title;
				this._hsimage__text.setAttribute('style','color:#FFF;-webkit-user-drag:none;min-width: 150px;');
				this._hsimage__bk = document.createElement('div');
				this._hsimage__bk.className='ggskin ggskin_bk';
				this._hsimage.appendChild(this._hsimage__text);
				this._hsimage.appendChild(this._hsimage__bk);
				this.__div.appendChild(this._hsimage);
			}
		};
		this.addSkinHotspot=function(hotspot) {
			return new SkinHotspotClass(me,hotspot);
		}
	};

	this.generateXML = function(pan,tilt,fov)
	{
		if(typeof pan === "undefined" || pan == null)
			pan = 0;
		if(typeof tilt === "undefined" || tilt == null)
			tilt = 0;
		if(typeof fov === "undefined" || fov == null)
			fov = 90;
		//var path = "images/";
		var baseXML = '<?xml version="1.0" encoding="UTF-8"?>';
		baseXML += '<panorama id=""><view fovmode="0" pannorth="0">';
		baseXML += '<start pan="'+pan+'" fov="'+fov+'" tilt="'+tilt+'"/>';
		baseXML += '<min pan="0" fov="5" tilt="-90"/>';
		baseXML += '<max pan="360" fov="120" tilt="90"/>';
		baseXML += '</view>';
		if(this.hotspots)
		{
			baseXML += '<hotspots>';
			for(var h in this.hotspots)
			{
				var hotspotName = (parseInt(h)+1);
				if(typeof this.hotspots[h].title !== "undefined")
					hotspotName = this.hotspots[h].title;
				baseXML += '<hotspot title="'+hotspotName+'" hotspot="'+h+'" target="" pan="'+this.hotspots[h].pan+'" skinid="" url="" id="'+h+'" tilt="'+this.hotspots[h].tilt+'"/>';
			}
			baseXML += '</hotspots>';
		}
		baseXML += '<media/>';
		baseXML += '<input tilescale="1" tile0url="'+this.basePath+this.cubeImages[0]+'" tile5url="'+this.basePath+this.cubeImages[5]+'" tilesize="'+this.titleSize+'" tile4url="'+this.basePath+this.cubeImages[4]+'" tile3url="'+this.basePath+this.cubeImages[3]+'" tile2url="'+this.basePath+this.cubeImages[2]+'" tile1url="'+this.basePath+this.cubeImages[1]+'">';
		baseXML += '<preview color="0x000000"/></input></panorama>';
		return baseXML;
	}
	
	this.getPanTiltFov = function()
	{
		return {
			pan : this.pano.getPan(),
			tilt : this.pano.getTilt(),
			fov : this.pano.getFov()
		};
	}
	
	this.setPanTiltFov = function(options)
	{
		if(typeof options.moveTo !== "undefined" && options.moveTo === true
			&& typeof options.pan !== "undefined"
			&& typeof options.tilt !== "undefined"
			&& typeof options.fov !== "undefined"
			) {
			this.pano.moveTo(options.pan,options.tilt,options.fov,5)
		} else {
			if(typeof options.pan !== "undefined")
				this.pano.setPan(options.pan)
			if(typeof options.tilt !== "undefined")
				this.pano.setTilt(options.tilt)
			if(typeof options.fov !== "undefined")
				this.pano.setFov(options.fov)
		}
		return true;
	}
	
	this.changePanoramaImage = function(images)
	{
		if(typeof images !== "undefined")
		{
			if(typeof images[0] !== "undefined")
				this.cubeImages[0] = images[0];
			if(typeof images.front !== "undefined")
				this.cubeImages[0] = images.front;
			
			if(typeof images[3] !== "undefined")
				this.cubeImages[1] = images[3];
			if(typeof images.left !== "undefined")
				this.cubeImages[1] = images.left;
			
			if(typeof images[2] !== "undefined")
				this.cubeImages[2] = images[2];
			if(typeof images.back !== "undefined")
				this.cubeImages[2] = images.back;
			
			if(typeof images[1] !== "undefined")
				this.cubeImages[3] = images[1];
			if(typeof images.right !== "undefined")
				this.cubeImages[3] = images.right;
			
			if(typeof images[4] !== "undefined")
				this.cubeImages[4] = images[4];
			if(typeof images.up !== "undefined")
				this.cubeImages[4] = images.up;
			
			if(typeof images[5] !== "undefined")
				this.cubeImages[5] = images[5];
			if(typeof images.down !== "undefined")
				this.cubeImages[5] = images.down;
		}
		
		var panTiltFov = this.getPanTiltFov();
		
		this.pano.readConfigString(this.generateXML(panTiltFov.pan,panTiltFov.tilt,panTiltFov.fov));
	}
	
	this.addNewHotspot = function(title,pointId,panTiltFov,callback)
	{
		var nowPanTiltFov = this.getPanTiltFov();
		if(typeof panTiltFov !== "undefined") {
			if (panTiltFov.tilt > 80)
				panTiltFov.tilt = 80
			if (panTiltFov.tilt < -80) {
				panTiltFov.tilt = -80
			}
			var info = {pan:panTiltFov.pan,tilt:panTiltFov.tilt,fov:panTiltFov.fov};
		}
		else {
			panTiltFov = nowPanTiltFov;
			if (panTiltFov.tilt > 80)
				panTiltFov.tilt = 80
			if (panTiltFov.tilt < -80) {
				panTiltFov.tilt = -80
			}
			var info = {pan:panTiltFov.pan,tilt:panTiltFov.tilt,fov:panTiltFov.fov};
		}
		if(typeof title !== "undefined")
			info.title = title;
		if(typeof callback == "function")
			info.callback = callback;
		if(typeof pointId !== "undefined")
			info.pointId = pointId;
		var total = this.hotspots.push(info);
		this.pano.readConfigString(this.generateXML(nowPanTiltFov.pan,nowPanTiltFov.tilt,nowPanTiltFov.fov));
		return {
			hotspotId : (total - 1),
			pointId : pointId,
			pan : panTiltFov.pan,
			tilt : panTiltFov.tilt,
			fov : panTiltFov.fov
		}
	}
	
	this.removeHotspot = function(id)
	{
		if(typeof this.hotspots[id] !== "undefined")
			delete(this.hotspots[id]);

		for(var t in this.hotspots)
		{
			if(this.hotspots[t].pointId === id)
				delete(this.hotspots[t]);
		}
		
		var panTiltFov = this.getPanTiltFov();
		this.pano.readConfigString(this.generateXML(panTiltFov.pan,panTiltFov.tilt,panTiltFov.fov));
	}
	
	
	this.clearHotspot = function()
	{
		this.hotspots = [];
		var panTiltFov = this.getPanTiltFov();
		this.pano.readConfigString(this.generateXML(panTiltFov.pan,panTiltFov.tilt,panTiltFov.fov));
	}
	
	this.gotoHotspot = function(id)
	{
		if(typeof this.hotspots[id] !== "undefined")
		{
			this.setPanTiltFov({
				pan: this.hotspots[id].pan,
				tilt: this.hotspots[id].tilt,
				fov: this.hotspots[id].fov,
				moveTo: true
			})
		}
	}
	
	this.updateHotspot = function(id,options)
	{
		var panTiltFov = this.getPanTiltFov();
		if (panTiltFov.tilt > 80)
			panTiltFov.tilt = 80
		if (panTiltFov.tilt < -80) {
			panTiltFov.tilt = -80
		}
		if(typeof this.hotspots[id] === "undefined") {
			for(var t in this.hotspots)
			{
				if(this.hotspots[t].pointId === id) {
					id = t
					break
				}
			}
		}
		if(typeof this.hotspots[id] !== "undefined")
		{
			this.hotspots[id].pan = panTiltFov.pan;
			this.hotspots[id].tilt = panTiltFov.tilt;
			this.hotspots[id].fov = panTiltFov.fov;
			if(typeof options !== "undefined")
			{
				for(i in options)
				{
					this.hotspots[id][i] = options[i];
				}
			}
		}
		
		this.pano.readConfigString(this.generateXML(panTiltFov.pan,panTiltFov.tilt,panTiltFov.fov));

		return {
			hotspotId : id,
			pointId : this.hotspots[id].pointId,
			pan : panTiltFov.pan,
			tilt : panTiltFov.tilt,
			fov : panTiltFov.fov
		}
	}

	if (ggHasHtml5Css3D() || ggHasWebGL()) {
		/* for(i = 0; i < 6; i++)
			this.cubeImages[i] = "dsc_3583-dsc_3585 Panorama_o_"+i+".jpg"; */

		this.pano= new pano2vrPlayer(container);
		this.pano.setLockedKeyboard(true);
		this.pano2vrSkin(this.pano,this);
		
		this.pano.readConfigString(this.generateXML());
		
	} 
}




// WEBPACK FOOTER //
// ./src/plugins/panoCoaches.js